var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.iso
    ? _c("span", {
        staticClass: "flag-icon",
        class: _vm.flagIconClass,
        attrs: { title: _vm.title || _vm.iso }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }